
import React from "react";
import { Camera, TrendingUp, Clock, Award } from "lucide-react";

const TocTocBenefits = () => {
  const benefits = [
    {
      icon: TrendingUp,
      title: "Venda mais rápido",
      description: "Imóveis com fotos profissionais vendem 32% mais rápido que a média do mercado",
      color: "bg-[#FF5605]"
    },
    {
      icon: Award,
      title: "Valorize seu patrimônio",
      description: "Destaque os pontos fortes do imóvel e aumente o interesse de potenciais compradores",
      color: "bg-[#3332FC]"
    },
    {
      icon: Camera,
      title: "Qualidade profissional",
      description: "Equipamentos de última geração e técnicas especializadas em fotografia imobiliária",
      color: "bg-[#FF5605]"
    },
    {
      icon: Clock,
      title: "Entrega rápida",
      description: "Receba suas fotos editadas e em alta resolução em até 48 horas",
      color: "bg-[#3332FC]"
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="text-center mb-20 animate-[fadeInUp_0.8s_ease-out_0.2s_both]">
          <h2 className="text-4xl md:text-5xl font-bold text-[#323031] mb-6">
            Por que escolher fotografia imobiliária profissional em <span className="text-[#FF5605]">Balneário Camboriú</span>?
          </h2>
          <p className="text-xl text-[#5B5A59] max-w-3xl mx-auto">
            Mais de 30k imóveis fotografados em Balneário Camboriú, Itajaí, Camboriú e Porto Belo com resultados comprovados no mercado imobiliário.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className={`feature-card bg-white rounded-3xl p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 animate-[zoomIn_0.6s_ease-out_${0.2 * (index + 1)}s_both]`}
            >
              <div className={`w-16 h-16 ${benefit.color} rounded-2xl flex items-center justify-center mx-auto mb-6`}>
                <benefit.icon className="h-8 w-8 text-white" />
              </div>
              
              <h3 className="text-xl font-bold text-[#323031] mb-4">
                {benefit.title}
              </h3>
              
              <p className="text-[#5B5A59] leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TocTocBenefits;
